import React from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {
  colors,
  H1Blueberry,
  HIntroGreen,
  standardWrapper,
} from "../../styles/helpers"
import Wysiwyg from "./Wysiwyg"

const RepeatableImageByContent = ({ data }) => {
  return (
    <RepeatableImageByContentSection>
      <div className="wrapper">
        <div className="title">
          <h2>{data.mainTitle}</h2>
          <h3>{data.mainSubTitle}</h3>
        </div>
        <div className="blocks">
          {data.blocks.map((block, index) => {
            const imageDisplay = getImage(
              block.image.localFile.childImageSharp.gatsbyImageData
            )
            const imageAlt = block.image.altText
            return (
              <BlockStyled color={block.backgroundColor} key={index}>
                <div className="image">
                  <GatsbyImage
                    image={imageDisplay}
                    alt={imageAlt}
                    layout="fixed"
                  />
                </div>
                <div className="content">
                  <Wysiwyg data={{ wysiwyg: block.content }} />
                </div>
              </BlockStyled>
            )
          })}
        </div>
      </div>
    </RepeatableImageByContentSection>
  )
}

const RepeatableImageByContentSection = styled.section`
  .wrapper {
    ${standardWrapper}
  }

  .title {
    width: 100%;
    margin-bottom: 3rem;
    text-align: center;

    h2 {
      ${H1Blueberry};
    }

    h3 {
      ${HIntroGreen};
    }
  }
`

const BlockStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 2.5rem;
  padding: 1rem;
  background-color: ${props =>
    props.color === "purple" ? colors.colorAlt : colors.colorTertiary};

  @media (min-width: 768px) {
    padding: 2rem 4.5rem 0;
  }

  .image {
    width: 100%;

    @media (min-width: 768px) {
      width: calc(25%);
      padding-top: 3rem;
      padding-bottom: 3rem;
    }
  }

  .content {
    width: 100%;
    padding: 0 1rem;

    @media (min-width: 768px) {
      width: calc(75%);
      padding: 0 3rem;
    }
  }
`

export default RepeatableImageByContent
